var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready && !_vm.useTilled)?_c('VendorSignupForStripe'):_vm._e(),(_vm.ready && _vm.useTilled)?_c('VendorSignupForTilled'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }